import { CURRENCIES, DEFAULT_CURRENCY } from '@mirai/locale';

import { fetchCurrency } from './fetchCurrency';
import { replaceUrlParams } from '../components/helpers/replaceUrlParams';
import { TYPE } from '../Core.constants';

export const getCurrency = async ({ id, instance = {}, isRates, type, urlParams = {} } = {}) => {
  let currency =
    urlParams.currency || instance.currency || (type === TYPE.HOTEL ? await fetchCurrency(id) : DEFAULT_CURRENCY);

  if (!CURRENCIES.includes(currency)) {
    currency = DEFAULT_CURRENCY;
    isRates && replaceUrlParams({ currency });
  }

  return currency;
};
